/*
We need to have aliases for some languages that are used for formatting
functions. This can be used to, for example, use the correct script for the
language.
*/
export const aliases = {
  sr: "sr-Latn",
  pt: "pt-BR",
} as { [locale: string]: string };

export function getFormatLocale(locale: string): string {
  return aliases[locale] ?? locale;
}
